import { gql } from "@apollo/client";

export const upsertCluster = gql`
    mutation upsertCluster($cluster: [cluster_insert_input!]!) {
        insert_cluster(
            objects: $cluster
            on_conflict: { constraint: cluster_pkey, update_columns: [cluster_id, name, corporate_id, mill_id] }
        ) {
            affected_rows
            returning {
                cluster_id
            }
        }
    }
`;

export const updateClusterCode = gql`
    mutation updateCluster($cluster_code_id: Int!, $changes: cluster_set_input!) {
        update_cluster(where: { cluster_id: { _eq: $cluster_code_id } }, _set: $changes) {
            affected_rows
            returning {
                cluster_id
                cluster_code
            }
        }
    }
`;

export const subscribeClusterDetailsClusterCodeBO = gql`
    subscription getCluster($cluster_id: Int!) {
        cluster(where: { cluster_id: { _eq: $cluster_id } }) {
            cluster_code
        }
    }
`;

export const getClusters = gql`
    query getClusters($mill_id: Int!) {
        cluster(where: { _and: [{ mill_id: { _eq: $mill_id } }, { is_enabled: { _eq: true } }] }) {
            cluster_id
            name
            is_enabled
            cluster_code
            machine_centers(where: { disabled_at: { _is_null: true } }) {
                machine_center_id
                name
                cluster {
                    cluster_id
                    name
                }
                production_line {
                    production_line_id
                    name
                }
            }
        }
    }
`;

export const softDeleteCluster = gql`
    mutation softDeleteCluster($cluster_id: Int!) {
        update_machine_center(where: { cluster_id: { _eq: $cluster_id } }, _set: { cluster_id: null }) {
            affected_rows
            returning {
                machine_center_id
                cluster_id
            }
        }
        update_cluster(where: { cluster_id: { _eq: $cluster_id } }, _set: { is_enabled: false }) {
            affected_rows
            returning {
                cluster_id
                is_enabled
            }
        }
    }
`;
